import React, { ReactElement } from "react";
import classNames from "classnames";
import moment from "moment";
import { ArrowDownIcon } from "@kursk/components/ui/icons";
import styles from "./DatePickerHeader.module.scss";

export const DatePickerHeader = ({ date, decreaseMonth, increaseMonth }): ReactElement => {
  return (
    <div className={styles.headerContainer}>
      <div className={classNames(styles.arrowIcon, styles.iconLeft)} onClick={decreaseMonth}>
        <ArrowDownIcon width={16} height={6} />
      </div>
      <div className={styles.dateInfo}>
        <div className={styles.textMonth}>{moment(date).format('MMMM YYYY')}</div>
        <div className={styles.textToday}>{`Сегодня ${moment().format('D MMMM YYYY')}`}</div>
      </div>
      <div className={classNames(styles.arrowIcon, styles.iconRight)} onClick={increaseMonth}>
        <ArrowDownIcon width={16} height={6} />
      </div>
    </div>
  )
}
